export enum CountryPhoneCode {
  BRAZIL = '55'
}
